module.exports = __webpack_public_path__ + "static/media/special-shapes-img.7c7919a9.svg";